import React from "react";
import '../css-coding/Article4.css';

import section1 from "../assets/article4-1.png";
import section2 from "../assets/article4-2.png";
import section3 from "../assets/article4-3.png";
import section4 from "../assets/article4-4.png";
import section5 from "../assets/article4-5.png";
import section6 from "../assets/article4-6.png";


const ArticleFour = () => {
  return (
    <div className="article-container">
      <section className="article-section">
        <img src={section1} alt="Earning as Video Editor" />
      </section>

      <section className="article-section">
        <img src={section2} alt="Tamil Creators Blueprint" />
        <p>
          <strong>Embed Youtube Video:</strong>{" "}
          <a href="https://youtu.be/vAGSQoWq5nY" target="_blank" rel="noreferrer">
            https://youtu.be/vAGSQoWq5nY
          </a>
        </p>
        <p>
          <strong>Watch Full Video:</strong>{" "}
          <a href="https://youtu.be/vAGSQoWq5nY" target="_blank" rel="noreferrer">
            Video Editing as a Career 2025 - Voice of Expertise
          </a>
        </p>
      </section>

      <section className="article-section">
        <img src={section3} alt="Why Video Editing is the Future" />
        <p className="highlight-text">
          Shahil Sheriff’s story is proof that video editing can transform your life.
        </p>
      </section>

      <section className="article-section">
        <img src={section4} alt="Shahil's Growth Journey" />
        <ul>
          <li>✅ He discovered the power of content.</li>
          <li>✅ He showcased his work online consistently.</li>
        </ul>
      </section>

      <section className="article-section">
        <img src={section5} alt="Client Message Strategy" />
        <ul>
          <li>✅ Worked with 100+ clients</li>
          <li>✅ Delivered over 3000+ videos</li>
          <li>✅ Built a consistent 6-figure income monthly</li>
          <li>✅ Helped others grow through video content</li>
        </ul>
      </section>

      <section className="article-section">
        <img src={section6} alt="Digital Asset Tips and YouTube Content" />
        <p className="content-note">
          Content Ideas: “How I edited this viral reel”, “Premiere Pro vs After Effects”,
          “Client project breakdown”, “Freelancing tips for editors”
        </p>
      </section>

      
      <div className="blog-grid">
        <div className="blog-card">
          <div className="blog-card-inner">
            <div className="blog-image-container">
              <img src="https://framerusercontent.com/images/9KaLpX336KWnNjpIS3903gd7rA.jpg?scale-down-to=512" alt="Blog 1" className="blog-image" />
            </div>
            <div className="blog-text-content">
              <div className="blog-topline">
                <span className="blog-tag">Articles</span>
                <span className="blog-date">Mar 15, 2023</span>
              </div>
              <h3 className="blog-title">Create a Landing Page That Performs Great</h3>
              <hr className="blog-divider" />
              <div className="blog-meta">
                <span className="blog-readtime">7 Min read</span>
                <a href="/article2" className="read-more">Read more →</a>
              </div>
            </div>
          </div>
        </div>

        <div className="blog-card">
          <div className="blog-card-inner">
            <div className="blog-image-container">
              <img src="https://framerusercontent.com/images/Yaaw84I9JCFcQIDD5G34LAopiM.jpg?scale-down-to=512" alt="Blog 2" className="blog-image" />
            </div>
            <div className="blog-text-content">
              <div className="blog-topline">
                <span className="blog-tag">FAQ</span>
                <span className="blog-date">Feb 28, 2022</span>
              </div>
              <h3 className="blog-title">How Can Designers Prepare for the Future?</h3>
              <hr className="blog-divider" />
              <div className="blog-meta">
                <span className="blog-readtime">6 Min read</span>
                <a href="/article3" className="read-more">Read more →</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleFour;
